import { render, staticRenderFns } from "./sortDialog.vue?vue&type=template&id=d8f4b75a&scoped=true"
import script from "./sortDialog.vue?vue&type=script&lang=js"
export * from "./sortDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f4b75a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8f4b75a')) {
      api.createRecord('d8f4b75a', component.options)
    } else {
      api.reload('d8f4b75a', component.options)
    }
    module.hot.accept("./sortDialog.vue?vue&type=template&id=d8f4b75a&scoped=true", function () {
      api.rerender('d8f4b75a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/processMonitoring/template/sortDialog.vue"
export default component.exports